module.exports = __webpack_public_path__ + "img/202311_06.b1e7cad7.jpg";